export enum TicketOrigin {
  ACTIVE = 'ACTIVE',
  RECEPTIVE = 'RECEPTIVE',
  BOT = 'BOT',
  BOT_CONCIERGE = 'BOT_CONCIERGE',
  APP = 'APP',
}

export const TicketOriginNames = {
  [TicketOrigin.ACTIVE]: 'Ativo',
  [TicketOrigin.RECEPTIVE]: 'Receptivo',
  [TicketOrigin.BOT]: 'GPT',
  [TicketOrigin.BOT_CONCIERGE]: 'GPT Concierge',
  [TicketOrigin.APP]: 'APP',
};
